import React, { useState, useEffect, useRef, useCallback } from "react";
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import { App as CapApp } from '@capacitor/app';
const API_URL = process.env.REACT_APP_API_URL || "https://api.hte.sn";

const LOGO_DATA_URI = "data:image/jpeg;base64,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";
const WAVE_LOGO_URI = "https://cdn.brandfetch.io/idg7vSSBJp/w/230/h/101/theme/dark/logo.png?c=1bxid64Mup7aczewSAYMX&t=1781712490919";
const OM_LOGO_URI = "https://cdn.brandfetch.io/id29r8rnyj/w/820/h/126/theme/light/logo.png?c=1bxid64Mup7aczewSAYMX&t=1781807922460";

// ── helpers ──────────────────────────────────────────────────────────────────

const fmt = (n) =>
  new Intl.NumberFormat("fr-FR").format(Math.round(Number(n) || 0));

const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
const statusBadge = (status) => {
  const map = {
    completed:  { bg: "#f0fdf4", color: "#16a34a", label: "✅ Validée" },
    cancelled:  { bg: "#fefce8", color: "#92400e", label: "⚠️ Annulée" },
    pending:    { bg: "#eff6ff", color: "#1d4ed8", label: "⏳ En attente" },
    processing: { bg: "#eff6ff", color: "#1d4ed8", label: "⏳ En cours" },
    failed:     { bg: "#fef2f2", color: "#991b1b", label: "❌ Échouée" },
  };
  const s = map[status] || { bg: "#f1f5f9", color: "#475569", label: status };
  return (
    <span style={{
      background: s.bg, color: s.color, borderRadius: 20,
      padding: "2px 10px", fontSize: 11, fontWeight: 600,
    }}>
      {s.label}
    </span>
  );
};
async function apiFetch(path, opts = {}) {
  const res = await fetch(`${API_URL}/api/client-portal${path}`, {
    headers: { "Content-Type": "application/json", ...opts.headers },
    ...opts,
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.detail || data.message || `Erreur ${res.status}`);
  }
  return data;
}

function WaveIcon({ size = 28 }) {
  return (
    <img src={WAVE_LOGO_URI} alt="Wave"
      style={{ width: size * 2.5, height: size, objectFit: "contain" }} />
  );
}

function OrangeMoneyIcon({ size = 28 }) {
  return (
    <img src={OM_LOGO_URI} alt="Orange Money"
      style={{ width: size * 3.5, height: size, objectFit: "contain" }} />
  );
}

// ── icônes SVG ──────────────────────────────────────────────────────────────

function BoltIcon({ size = 24, color = "currentColor", style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style} xmlns="http://www.w3.org/2000/svg">
      <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
  );
}

function PlugIcon({ size = 24, color = "currentColor", style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" style={style} xmlns="http://www.w3.org/2000/svg">
      <path d="M9 2v6" />
      <path d="M15 2v6" />
      <path d="M6 8h12a2 2 0 0 1 2 2v2a8 8 0 0 1-8 8 8 8 0 0 1-8-8v-2a2 2 0 0 1 2-2Z" />
      <path d="M12 18v4" />
    </svg>
  );
}

// ── micro-components ─────────────────────────────────────────────────────────

function Spinner({ size = 20, color = "#15803d" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      style={{ animation: "spin 0.8s linear infinite", display: "inline-block" }}>
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="3" opacity=".25" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke={color} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function Toast({ msg, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [onClose]);

  const colors = {
    success: { bg: "#d1fae5", border: "#6ee7b7", text: "#065f46", icon: "✅" },
    error: { bg: "#fee2e2", border: "#fca5a5", text: "#991b1b", icon: "❌" },
    info: { bg: "#dcfce7", border: "#86efac", text: "#15803d", icon: "ℹ️" },
    warning: { bg: "#fef3c7", border: "#fcd34d", text: "#92400e", icon: "⚠️" },
  }[type] || { bg: "#f1f5f9", border: "#cbd5e1", text: "#334155", icon: "💬" };

  return (
    <div style={{
      position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)",
      background: colors.bg, border: `1.5px solid ${colors.border}`, color: colors.text,
      borderRadius: 14, padding: "14px 22px", fontWeight: 600, fontSize: 14, zIndex: 9999,
      maxWidth: 380, width: "calc(100% - 32px)", boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
      display: "flex", gap: 10, alignItems: "flex-start", animation: "slideUp 0.3s ease",
    }}>
      <span style={{ fontSize: 18, lineHeight: 1 }}>{colors.icon}</span>
      <span style={{ flex: 1, lineHeight: 1.4 }}>{msg}</span>
      <button onClick={onClose} style={{
        background: "none", border: "none", cursor: "pointer", color: colors.text,
        opacity: 0.6, fontSize: 18, lineHeight: 1, padding: 0, flexShrink: 0,
      }}>×</button>
    </div>
  );
}

function TokenCard({ token, kwh, txnId, isVictron, isWater, onCopy }) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(token).then(() => {
      setCopied(true);
      onCopy?.();
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const digits = token.replace(/\s/g, '');
  const parts = digits.match(/.{1,4}/g) || [digits];

  return (
    <div style={{
      background: "linear-gradient(135deg, #14532d 0%, #16a34a 60%, #15803d 100%)",
      borderRadius: 20, padding: "28px 24px", color: "#fff", textAlign: "center",
      position: "relative", overflow: "hidden", boxShadow: "0 12px 40px rgba(22,163,74,0.3)",
    }}>
      <div style={{ position: "absolute", top: -30, right: -30, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.07)" }} />
      <div style={{ position: "absolute", bottom: -20, left: -20, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,0.05)" }} />

      <div style={{ marginBottom: 6, display: "flex", justifyContent: "center" }}>
        <BoltIcon size={36} color="#fff" />
      </div>

      <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 4, letterSpacing: 1 }}>
        {isVictron
          ? "CODE VICTRON PAYG"
          : isWater
            ? `TOKEN EAU${kwh > 0 ? ` — ${kwh.toFixed(3)} m³` : ""}`
            : `TOKEN STS${kwh > 0 ? ` — ${kwh.toFixed(2)} kWh` : ""}`}
      </div>

      <div style={{
        fontFamily: "'Courier New', monospace", fontSize: 22, fontWeight: 800, letterSpacing: 4,
        background: "rgba(255,255,255,0.12)", borderRadius: 10, padding: "16px 12px",
        margin: "14px 0", wordBreak: "break-all", lineHeight: 1.7,
      }}>
        {parts.join("  ")}
      </div>

      <p style={{ fontSize: 12, opacity: 0.7, marginBottom: 16 }}>
        {isVictron
          ? "Saisissez ce code sur votre appareil Victron"
          : isWater
            ? "Saisissez ce code sur votre compteur d'eau"
            : "Saisissez ce code dans votre compteur"}
      </p>

      <button onClick={copy} style={{
        background: copied ? "rgba(255,255,255,0.35)" : "rgba(255,255,255,0.2)",
        border: "1.5px solid rgba(255,255,255,0.4)", color: "#fff", borderRadius: 10,
        padding: "10px 28px", fontWeight: 700, fontSize: 14, cursor: "pointer",
        transition: "all 0.2s", letterSpacing: 0.5,
      }}>
        {copied ? "✓ Copié !" : "📋 Copier le token"}
      </button>

      {txnId && (
        <p style={{ fontSize: 10, opacity: 0.5, marginTop: 14, fontFamily: "monospace" }}>
          {txnId}
        </p>
      )}
    </div>
  );
}

// ── SECTION: Lookup compteur ──────────────────────────────────────────────────

function MeterLookup({ onMeterLoaded }) {
  const [val, setVal] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [recentMeters, setRecentMeters] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("madpower_recent_meters") || "[]");
    } catch {
      return [];
    }
  });

  const search = async (meterId) => {
    const id = (meterId || val).trim();
    if (!id) { setError("Entrez un numéro de compteur"); return; }
    setLoading(true);
    setError("");
    try {
      const data = await apiFetch(`/client/meter/${encodeURIComponent(id)}`);

      const updated = [
        { meter_id: data.meter_id, customer_name: data.customer_name },
        ...recentMeters.filter((m) => m.meter_id !== data.meter_id),
      ].slice(0, 5);
      localStorage.setItem("madpower_recent_meters", JSON.stringify(updated));
      setRecentMeters(updated);

      onMeterLoaded(data);
    } catch (e) {
      setError("Numéro de compteur incorrect. Veuillez vérifier et réessayer.");
    } finally {
      setLoading(false);
    }
  };

  const removeRecent = (meterId, e) => {
    e.stopPropagation();
    const updated = recentMeters.filter((m) => m.meter_id !== meterId);
    localStorage.setItem("madpower_recent_meters", JSON.stringify(updated));
    setRecentMeters(updated);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: 88, height: 88, borderRadius: 20, background: "#000",
        display: "flex", alignItems: "center", justifyContent: "center",
        margin: "0 auto 8px", overflow: "hidden", boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
      }}>
        <img src={LOGO_DATA_URI} alt="NAAT" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
      <h2 style={{ fontSize: 22, fontWeight: 800, color: "#111827", marginBottom: 6 }}>
        Recharge d'électricité et d'eau
      </h2>
      <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 28, lineHeight: 1.5 }}>
        Entrez votre numéro de compteur pour acheter du courant ou de l'eau
        et consulter votre historique.
      </p>

      <div style={{ position: "relative", marginBottom: 12 }}>
        <input
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && search()}
          placeholder="Ex : 5810..."
          style={{
            width: "100%", boxSizing: "border-box", padding: "16px 56px 16px 20px",
            borderRadius: 14, border: error ? "2px solid #ef4444" : "2px solid #e5e7eb",
            fontSize: 18, fontWeight: 600, outline: "none", fontFamily: "monospace",
            letterSpacing: 2, transition: "border 0.2s", background: "#f9fafb",
          }}
          onFocus={(e) => (e.target.style.border = "2px solid #15803d")}
          onBlur={(e) => (e.target.style.border = error ? "2px solid #ef4444" : "2px solid #e5e7eb")}
        />
        {loading && (
          <span style={{ position: "absolute", right: 18, top: "50%", transform: "translateY(-50%)" }}>
            <Spinner />
          </span>
        )}
      </div>

      {error && (
        <p style={{ color: "#ef4444", fontSize: 13, marginBottom: 12, textAlign: "left" }}>
          ⚠️ {error}
        </p>
      )}

      <button
        onClick={() => search()}
        disabled={loading}
        style={{
          width: "100%", padding: "15px",
          background: loading ? "#9ca3af" : "linear-gradient(135deg, #16a34a, #15803d)",
          color: "#fff", border: "none", borderRadius: 14, fontSize: 16, fontWeight: 700,
          cursor: loading ? "not-allowed" : "pointer", display: "flex", alignItems: "center",
          justifyContent: "center", gap: 10,
          boxShadow: loading ? "none" : "0 4px 16px rgba(22,163,74,0.35)", transition: "all 0.2s",
        }}
      >
        {loading ? <><Spinner size={18} color="#fff" /> Recherche...</> : "🔍 Rechercher mon compteur"}
      </button>

      {recentMeters.length > 0 && (
        <div style={{ marginTop: 28, textAlign: "left" }}>
          <p style={{
            fontSize: 12, fontWeight: 700, color: "#9ca3af", letterSpacing: 1,
            marginBottom: 10, textTransform: "uppercase",
          }}>
            Compteurs récents
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {recentMeters.map((m) => (
              <button
                key={m.meter_id}
                onClick={() => search(m.meter_id)}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "12px 16px", background: "#f9fafb", border: "1.5px solid #e5e7eb",
                  borderRadius: 12, cursor: "pointer", transition: "all 0.15s",
                  textAlign: "left", width: "100%",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.border = "1.5px solid #15803d";
                  e.currentTarget.style.background = "#f0fdf4";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.border = "1.5px solid #e5e7eb";
                  e.currentTarget.style.background = "#f9fafb";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10,
                    background: "linear-gradient(135deg, #16a34a, #15803d)",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <BoltIcon size={18} color="#fff" />
                  </div>
                  <div>
                    <p style={{
                      fontSize: 14, fontWeight: 700, color: "#111827", fontFamily: "monospace",
                      letterSpacing: 1, margin: 0,
                    }}>
                      {m.meter_id}
                    </p>
                    <p style={{ fontSize: 12, color: "#6b7280", margin: "2px 0 0 0" }}>
                      {m.customer_name}
                    </p>
                  </div>
                </div>

                <span
                  onClick={(e) => removeRecent(m.meter_id, e)}
                  style={{
                    fontSize: 16, color: "#d1d5db", cursor: "pointer", padding: "4px 6px",
                    borderRadius: 6, lineHeight: 1, flexShrink: 0,
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "#ef4444")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "#d1d5db")}
                  title="Supprimer"
                >
                  ×
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── SECTION: Infos compteur + achat ──────────────────────────────────────────

function PurchasePanel({ meter, onBack, onSuccess, showToast }) {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("wave");
  const [loading, setLoading] = useState(false);
  const [wavePolling, setWavePolling] = useState(false);
  const [waveUrl, setWaveUrl] = useState("");
  const [checkoutId, setCheckoutId] = useState("");
  const pollingRef = useRef(null);

  const isVictron = meter.is_victron;
  const isWater = !!meter.is_water;          // ✅ compteur à eau GOMELONG
  const unit = isWater ? "m³" : "kWh";
  const [victronMonths, setVictronMonths] = useState(1);
  const victronAmount = isVictron ? (meter.victron_monthly_price || 0) * victronMonths : 0;

  const MINIMUM = meter.minimum_amount || 500;

  const tariff = meter.tariff || 112;
  const amountNum = parseFloat(amount) || 0;
  const debt = meter.total_debt || 0;
  const elec = Math.max(0, amountNum - debt);
  const kwh = elec > 0 ? (elec / tariff).toFixed(isWater ? 3 : 2) : "0.00";

  const quickAmounts = (() => {
    const base = [1000, 2000, 3000, 5000, 10000];
    if (debt > 0) {
      return base.map((b) => Math.ceil((debt + b) / 100) * 100);
    }
    return base;
  })();

  const amountValid =
    amountNum >= MINIMUM &&
    (debt === 0 || amountNum >= debt) &&
    (elec === 0 || elec >= MINIMUM);

  const amountError = (() => {
    if (!amount) return "";
    if (amountNum < MINIMUM) return `Minimum ${MINIMUM} FCFA`;
    if (debt > 0 && amountNum < debt)
      return `Redevances dues: ${fmt(debt)} FCFA — votre montant est insuffisant`;
    if (elec > 0 && elec < MINIMUM)
      return `Après redevances (${fmt(debt)} FCFA), il reste ${fmt(elec)} FCFA — insuffisant pour l'électricité (min ${MINIMUM} FCFA)`;
    return "";
  })();

  // ✅ Validité globale du bouton payer, selon le type de compteur
  const payDisabled = isVictron
    ? loading || !meter.victron_monthly_price || victronAmount <= 0
    : !amountValid || loading;

  useEffect(() => () => clearInterval(pollingRef.current), []);

  useEffect(() => {
  if (!wavePolling || !checkoutId) return;

  let listenerHandle;
  CapApp.addListener('resume', async () => {
    try {
      const res = await apiFetch(`/client/purchase/wave/status/${checkoutId}`);
      if (res.status === "completed") {
        stopPolling();
        setWavePolling(false);
        if (Capacitor.isNativePlatform()) {
          try { await Browser.close(); } catch (_) {}
        }
        showToast("Paiement Wave confirmé ! 🎉", "success");
        onSuccess({
          transaction_id: res.transaction_id,
          token: res.token,
          kwh: res.kwh,
          amount: res.amount,
          payment_method: "wave",
          is_victron: res.is_victron || false,
          is_water: res.is_water || false,
          victron_months: res.victron_months,
          victron_expiry_date: res.victron_expiry_date,
        });
      } else if (["failed", "cancelled", "expired"].includes(res.status)) {
        stopPolling();
        setWavePolling(false);
        showToast(res.message || "Paiement annulé ou échoué.", "error");
      }
    } catch (_) {}
  }).then(handle => { listenerHandle = handle; });

  return () => { if (listenerHandle) listenerHandle.remove(); };
}, [wavePolling, checkoutId]);

  const stopPolling = () => {
    clearInterval(pollingRef.current);
    pollingRef.current = null;
  };

  const startPolling = (cid) => {
    let tries = 0;
    const max = 120;
    pollingRef.current = setInterval(async () => {
      tries++;
      if (tries > max) {
        stopPolling();
        setWavePolling(false);
        showToast("Le délai a expiré. Réessayez.", "error");
        return;
      }
      try {
        const res = await apiFetch(`/client/purchase/wave/status/${cid}`);

        if (res.status === "completed") {
          stopPolling();
          setWavePolling(false);

          // ✅ Fermer l'overlay Wave/navigateur pour revenir direct sur l'app native
          if (Capacitor.isNativePlatform()) {
            try { await Browser.close(); } catch (_) { }
          }

          showToast("Paiement Wave confirmé ! 🎉", "success");
          onSuccess({
            transaction_id: res.transaction_id,
            token: res.token,
            kwh: res.kwh,
            amount: res.amount,
            payment_method: "wave",
            is_victron: res.is_victron || false,
            is_water: res.is_water || false,
            victron_months: res.victron_months,
            victron_expiry_date: res.victron_expiry_date,
          });

        } else if (res.status === "processing") {
          // APRÈS
        } else if (res.status === "cancelled") {
          stopPolling();
          setWavePolling(false);
          if (Capacitor.isNativePlatform()) {
            try { await Browser.close(); } catch (_) { }
          }
          showToast(res.message || "Paiement annulé.", "warning");
        } else if (["failed", "expired"].includes(res.status)) {
          stopPolling();
          setWavePolling(false);
          if (Capacitor.isNativePlatform()) {
            try { await Browser.close(); } catch (_) { }
          }
          showToast(res.message || "Paiement échoué.", "error");
        }
          // Webhook pas encore arrivé, on continue à poller silencieusement
        // } else if (["failed", "cancelled", "expired"].includes(res.status)) {
        //   stopPolling();
        //   setWavePolling(false);
        //   if (Capacitor.isNativePlatform()) {
        //     try { await Browser.close(); } catch (_) { }
        //   }
        //   showToast(res.message || "Paiement annulé ou échoué.", "error");
        // }
      } catch (_) { }
    }, 2000);
  };

  const handleSubmit = async () => {
    const finalAmount = isVictron ? victronAmount : amountNum;

    if (isVictron) {
      if (!meter.victron_monthly_price || finalAmount <= 0) return;
    } else {
      if (!amountValid) return;
    }

    setLoading(true);
    try {
      // if (method === "wave") {
      //   const res = await apiFetch("/client/purchase/wave", {
      //     method: "POST",
      //     body: JSON.stringify({ meter_id: meter.meter_id, amount: finalAmount }),
      //   });

      //   localStorage.setItem("madpower_pending_checkout", res.checkout_id);
      //   localStorage.setItem("madpower_last_meter", JSON.stringify(meter));

      //   setCheckoutId(res.checkout_id);
      //   setWaveUrl(res.wave_launch_url);
      //   setWavePolling(true);
      //   startPolling(res.checkout_id);


      //   // }
      //   if (res.wave_launch_url) {
      //     // ✅ Sauvegarder d'abord
      //     localStorage.setItem("madpower_pending_checkout", res.checkout_id);
      //     localStorage.setItem("madpower_last_meter", JSON.stringify(meter));

      //     setCheckoutId(res.checkout_id);
      //     setWaveUrl(res.wave_launch_url);

      //     // ✅ Ouvrir Wave IMMÉDIATEMENT — avant setWavePolling
      //     // if (window.Capacitor && window.Capacitor.isNativePlatform()) {
      //     //   const waveUrl = res.wave_launch_url;
      //     //   const waveScheme = waveUrl.replace('https://wave.com', 'wave://');
      //     //   window.location.href = waveScheme;
      //     //   setTimeout(() => {
      //     //     window.location.href = waveUrl;
      //     //   }, 1500);
      //     // } 
      //     // else {
      //     //   window.open(res.wave_launch_url, "_blank");
      //     // }
      //     if (Capacitor.isNativePlatform()) {
      //       const waveUrl = res.wave_launch_url;
      //       const waveScheme = waveUrl.replace('https://wave.com', 'wave://');

      //       window.location.href = waveScheme;
      //     } else {
      //       window.open(res.wave_launch_url, "_blank");
      //     }

      //     // ✅ Afficher l'écran d'attente après
      //     setWavePolling(true);
      //     startPolling(res.checkout_id);
      //   }

      // } 
      if (method === "wave") {
        const res = await apiFetch("/client/purchase/wave", {
          method: "POST",
          body: JSON.stringify({
            meter_id: meter.meter_id,
            amount: finalAmount,
          }),
        });

        if (!res.wave_launch_url || !res.checkout_id) {
          throw new Error("Lien de paiement Wave invalide.");
        }

        // Sauvegarder le paiement en attente
        localStorage.setItem(
          "madpower_pending_checkout",
          res.checkout_id
        );

        localStorage.setItem(
          "madpower_last_meter",
          JSON.stringify(meter)
        );

        setCheckoutId(res.checkout_id);
        setWaveUrl(res.wave_launch_url);

        // Un seul polling
        setWavePolling(true);
        startPolling(res.checkout_id);

        // Une seule ouverture de Wave
        if (Capacitor.isNativePlatform()) {
          const waveScheme = res.wave_launch_url.replace(
            /^https:\/\/wave\.com/,
            "wave://"
          );

          window.location.href = waveScheme;
        } else {
          window.open(res.wave_launch_url, "_blank");
        }
      }
      else {
        const res = await apiFetch("/client/purchase/cash", {
          method: "POST",
          body: JSON.stringify({
            meter_id: meter.meter_id,
            amount: finalAmount,
            payment_method: method,
          }),
        });
        showToast(
          isVictron
            ? "Abonnement activé !"
            : method === "orange_money"
              ? "Paiement Orange Money enregistré !"
              : "Achat confirmé !",
          "success"
        );
        onSuccess(res);
      }
    } catch (e) {
      showToast(e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Header compteur */}
      <button
        onClick={onBack}
        style={{
          background: "none", border: "none", cursor: "pointer", color: "#6b7280",
          fontSize: 13, display: "flex", alignItems: "center", gap: 6,
          marginBottom: 16, padding: 0,
        }}
      >
        ← Changer de compteur
      </button>

      {/* Carte info compteur */}
      <div style={{
        background: "linear-gradient(135deg, #f0fdf4, #dcfce7)", border: "1.5px solid #86efac",
        borderRadius: 16, padding: "18px 20px", marginBottom: 20,
      }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start", textAlign:"center" }}>
          <div>
            <p style={{ fontSize: 12, color: "#16a34a", fontWeight: 600, marginBottom: 2 }}>
              COMPTEUR
            </p>
            <p style={{
              fontSize: 20, fontWeight: 800, color: "#14532d",
              fontFamily: "monospace", letterSpacing: 2,
            }}>
              {meter.meter_id}
            </p>
            <p style={{ fontSize: 14, color: "#15803d", marginTop: 2 }}>
              {meter.customer_name}
            </p>
          </div>
          {/* {!isVictron && (
            <div style={{ textAlign: "right" }}>
              <p style={{ fontSize: 11, color: "#16a34a" }}>Cumul des achats (kWh)</p>
              <p style={{ fontSize: 22, fontWeight: 800, color: "#14532d" }}>
                {Number(meter.current_balance_kwh || 0).toFixed(2)}
              </p>
              <p style={{ fontSize: 11, color: "#16a34a" }}>kWh</p>
            </div>
          )} */}
        </div>

        <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
          <span style={{
            padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
            background: meter.is_suspended ? "#fee2e2" : "#bbf7d0",
            color: meter.is_suspended ? "#991b1b" : "#14532d",
          }}>
            {meter.is_suspended ? "🔒 SUSPENDU" : "✅ ACTIF"}
          </span>
          {isWater && (
            <span style={{
              padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
              background: "#cffafe", color: "#155e75",
            }}>
              💧 EAU · {fmt(tariff)} FCFA/m³
            </span>
          )}
          {/* {!isVictron ? (
            <span style={{
              padding: "3px 10px", borderRadius: 20, fontSize: 11,
              background: "#dcfce7", color: "#14532d", fontWeight: 600,
            }}>
              {meter.tariff} FCFA/kWh
            </span>
          ) : (
            <span style={{
              padding: "3px 10px", borderRadius: 20, fontSize: 11,
              background: "#fef3c7", color: "#92400e", fontWeight: 600,
              display: "inline-flex", alignItems: "center", gap: 4,
            }}>
              <BoltIcon size={11} color="#92400e" /> {meter.victron_subscription_label}
            </span>
          )} */}
        </div>
      </div>

      {/* Alerte dette — n'existe pas pour Victron */}
      {!isVictron && debt > 0 && (
        <div style={{
          background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 12,
          padding: "14px 16px", marginBottom: 16,
        }}>
          <p style={{ fontWeight: 700, color: "#9a3412", marginBottom: 4, fontSize: 14 }}>
            ⚠️ Redevances impayées — {fmt(debt)} FCFA
          </p>
          <p style={{ fontSize: 12, color: "#c2410c" }}>
            {meter.unpaid_fees_count} mois impayé(s). Cette somme sera déduite de votre prochain paiement.
          </p>
          {meter.unpaid_fees?.map((f, i) => (
            <div key={i} style={{
              display: "flex", justifyContent: "space-between", fontSize: 12,
              color: "#9a3412", marginTop: 4,
            }}>
              <span>{f.period}</span>
              <span>{fmt(f.remaining)} FCFA</span>
            </div>
          ))}
        </div>
      )}

      {/* En cours Wave */}
      {wavePolling && (
        <div style={{
          background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: 14,
          padding: "18px 16px", marginBottom: 18, textAlign: "center",
        }}>
          <Spinner size={28} color="#16a34a" />
          <p style={{ fontWeight: 700, color: "#16a34a", marginTop: 10, marginBottom: 6 }}>
            En attente du paiement Wave…
          </p>

          <div style={{
            background: "#fff", border: "1px solid #bbf7d0", borderRadius: 10,
            padding: "12px 14px", marginBottom: 14, textAlign: "left",
          }}>
            {[
              "Ouvrez Wave ci-dessous",
              "Confirmez le paiement",
              "Revenez ici — le token s'affiche automatiquement",
            ].map((s, i) => (
              <div key={i} style={{
                display: "flex", alignItems: "flex-start", gap: 10, marginBottom: i < 2 ? 8 : 0,
              }}>
                <div style={{
                  minWidth: 22, height: 22, borderRadius: "50%", background: "#16a34a",
                  color: "#fff", fontSize: 11, fontWeight: 700, display: "flex",
                  alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1,
                }}>
                  {i + 1}
                </div>
                <span style={{ fontSize: 13, color: "#15803d", lineHeight: 1.4 }}>{s}</span>
              </div>
            ))}
          </div>

          {waveUrl && (
            <a href={waveUrl} target="_blank" rel="noreferrer" style={{
              display: "block", background: "#16a34a", color: "#fff", borderRadius: 10,
              padding: "12px 22px", fontWeight: 700, fontSize: 14, textDecoration: "none",
              marginBottom: 10,
            }}>
              🌊 Ouvrir Wave pour payer
            </a>
          )}

          <p style={{ fontSize: 11, color: "#86efac", marginBottom: 10 }}>
            Cette page se met à jour automatiquement après votre paiement.
          </p>

          <button
            onClick={async () => {
              try { await apiFetch(`/client/purchase/wave/cancel/${checkoutId}`, { method: "POST" }); } catch (_) { }
              stopPolling(); setWavePolling(false); setWaveUrl("");
            }}
          // onClick={() => { stopPolling(); setWavePolling(false); setWaveUrl(""); }}
          // style={{
          //   background: "none", border: "none", color: "#6b7280", cursor: "pointer",
          //   fontSize: 12, textDecoration: "underline",
          // }}
          >
            Annuler
          </button>
        </div>
      )}

      {!wavePolling && (
        <>
          {/* Méthode de paiement */}
          <div style={{ marginBottom: 18 }}>
            <p style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 10 }}>
              Mode de paiement
            </p>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <button
                onClick={() => setMethod("wave")}
                style={{
                  padding: "14px 8px",
                  border: method === "wave" ? "2.5px solid #16a34a" : "2px solid #e5e7eb",
                  borderRadius: 12, background: method === "wave" ? "#16a34a12" : "#f9fafb",
                  cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                  display: "flex", flexDirection: "column", alignItems: "center",
                  justifyContent: "center", gap: 6,
                }}
              >
                <WaveIcon size={22} />
                <p style={{ fontSize: 12, fontWeight: 700, color: method === "wave" ? "#16a34a" : "#374151", margin: 0 }}>
                  Wave
                </p>
              </button>

              <div style={{
                padding: "14px 8px", border: "2px solid #e5e7eb", borderRadius: 12,
                background: "#f9fafb", textAlign: "center", opacity: 0.55,
                cursor: "not-allowed", position: "relative", display: "flex",
                flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 6,
              }}>
                <OrangeMoneyIcon size={22} />
                <p style={{ fontSize: 12, fontWeight: 700, color: "#374151", margin: 0 }}>Orange Money</p>
                <span style={{
                  position: "absolute", top: 6, right: 6, background: "#f3f4f6",
                  border: "1px solid #e5e7eb", borderRadius: 20, fontSize: 9, fontWeight: 700,
                  color: "#9ca3af", padding: "2px 6px", letterSpacing: 0.3,
                }}>
                  BIENTÔT
                </span>
              </div>
            </div>
          </div>

          {/* ✅ Bloc montant : Victron OU classique, jamais les deux */}
          {isVictron ? (
            <div style={{ marginBottom: 18 }}>
              <div style={{
                background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 12,
                padding: "14px 16px", marginBottom: 14,
              }}>
                <p style={{ fontWeight: 700, color: "#9a3412", marginBottom: 4 }}>
                  ⚡ {meter.victron_subscription_label}
                </p>
                <p style={{ fontSize: 13, color: "#c2410c" }}>
                  {fmt(meter.victron_monthly_price)} FCFA / mois
                </p>
                {meter.victron_expiry_date && (
                  <p style={{ fontSize: 12, color: "#c2410c", marginTop: 4 }}>
                    Expire le {new Date(meter.victron_expiry_date).toLocaleDateString("fr-FR")}
                  </p>
                )}
              </div>

              <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 8 }}>
                Nombre de mois
              </label>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
                {[1, 2, 3, 6].map((m) => (
                  <button
                    key={m}
                    onClick={() => setVictronMonths(m)}
                    style={{
                      padding: "10px 18px", borderRadius: 12,
                      border: victronMonths === m ? "2px solid #15803d" : "1.5px solid #d1d5db",
                      background: victronMonths === m ? "#15803d" : "#f9fafb",
                      color: victronMonths === m ? "#fff" : "#374151",
                      fontWeight: 700, cursor: "pointer",
                    }}
                  >
                    {m} mois
                  </button>
                ))}
              </div>

              <div style={{
                background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: 12,
                padding: "14px 16px", display: "flex", justifyContent: "space-between",
              }}>
                <span style={{ color: "#16a34a", fontWeight: 600 }}>Total à payer</span>
                <span style={{ fontWeight: 800, color: "#16a34a", fontSize: 18 }}>
                  {fmt(victronAmount)} FCFA
                </span>
              </div>
            </div>
          ) : (
            <>
              {/* Saisie montant */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 8 }}>
                  Montant (FCFA)
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    min={MINIMUM}
                    step={100}
                    placeholder={`Minimum ${MINIMUM} FCFA`}
                    style={{
                      width: "100%", boxSizing: "border-box", padding: "16px 20px",
                      borderRadius: 12,
                      border: amountError ? "2px solid #ef4444" : amount && amountValid ? "2px solid #22c55e" : "2px solid #e5e7eb",
                      fontSize: 20, fontWeight: 700, outline: "none", background: "#f9fafb",
                    }}
                  />
                </div>

                {amountError && (
                  <p style={{ color: "#ef4444", fontSize: 12, marginTop: 6 }}>⚠️ {amountError}</p>
                )}
              </div>

              {/* Montants rapides */}
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                {quickAmounts.map((q) => (
                  <button
                    key={q}
                    onClick={() => setAmount(String(q))}
                    style={{
                      padding: "7px 14px", borderRadius: 20, border: "1.5px solid #d1d5db",
                      background: amount === String(q) ? "#15803d" : "#f3f4f6",
                      color: amount === String(q) ? "#fff" : "#374151", fontWeight: 600,
                      fontSize: 13, cursor: "pointer", transition: "all 0.15s",
                    }}
                  >
                    {fmt(q)}
                  </button>
                ))}
              </div>

              {/* Aperçu */}
              {amountNum >= MINIMUM && amountValid && (
                <div style={{
                  background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: 12,
                  padding: "14px 16px", marginBottom: 18, fontSize: 13,
                }}>
                  <p style={{ fontWeight: 700, color: "#16a34a", marginBottom: 8 }}>
                    📊 Récapitulatif
                  </p>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ color: "#4b5563" }}>Montant payé</span>
                    <span style={{ fontWeight: 700 }}>{fmt(amountNum)} FCFA</span>
                  </div>
                  {debt > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                      <span style={{ color: "#ea580c" }}>— Redevances</span>
                      <span style={{ fontWeight: 700, color: "#ea580c" }}>{fmt(debt)} FCFA</span>
                    </div>
                  )}
                  <div style={{
                    display: "flex", justifyContent: "space-between", borderTop: "1px solid #bbf7d0",
                    paddingTop: 6, marginTop: 4,
                  }}>
                    <span style={{ color: "#16a34a", fontWeight: 600, display: "flex", alignItems: "center", gap: 4 }}>
                      {isWater ? "💧 Eau" : <><BoltIcon size={14} color="#16a34a" /> Électricité</>}
                    </span>
                    <span style={{ fontWeight: 800, color: "#16a34a" }}>{fmt(elec)} FCFA</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                    <span style={{ color: "#059669" }}>≈ {isWater ? "Volume" : "Crédit"}</span>
                    <span style={{ fontWeight: 800, color: "#059669", fontSize: 15 }}>{kwh} {unit}</span>
                  </div>
                </div>
              )}
            </>
          )}

          {!isVictron && debt > 0 && (
            <div style={{
              background: "#fefce8", border: "1px solid #fde68a", borderRadius: 10,
              padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#92400e",
            }} />
          )}

          {/* Bouton payer */}
          <button
            onClick={handleSubmit}
            disabled={payDisabled}
            style={{
              width: "100%", padding: "16px",
              background: payDisabled
                ? "#9ca3af"
                : method === "wave"
                  ? "linear-gradient(135deg, #16a34a, #22c55e)"
                  : "linear-gradient(135deg, #ea580c, #f97316)",
              color: "#fff", border: "none", borderRadius: 14, fontSize: 16, fontWeight: 800,
              cursor: payDisabled ? "not-allowed" : "pointer", display: "flex",
              alignItems: "center", justifyContent: "center", gap: 10,
              boxShadow: payDisabled ? "none" : "0 4px 20px rgba(0,0,0,0.2)",
              transition: "all 0.2s", letterSpacing: 0.5,
            }}
          >
            {loading ? (
              <><Spinner size={18} color="#fff" /> Traitement…</>
            ) : method === "wave" ? (
              <><WaveIcon size={18} /> Payer {fmt(isVictron ? victronAmount : amountNum)} FCFA avec Wave</>
            ) : (
              <><OrangeMoneyIcon size={18} /> Confirmer le paiement Orange Money</>
            )}
          </button>

          {method === "orange_money" && (
            <p style={{ textAlign: "center", fontSize: 11, color: "#9ca3af", marginTop: 8 }}>
              Le paiement Orange Money doit être confirmé avec votre agent.
            </p>
          )}
        </>
      )}
    </div>
  );
}

// ── SECTION: Succès + token ───────────────────────────────────────────────────

function SuccessPanel({ result, meter, onNewPurchase, onHistory }) {
  const [copied, setCopied] = useState(false);

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: 72, height: 72, borderRadius: "50%",
        background: "linear-gradient(135deg, #16a34a, #15803d)",
        display: "flex", alignItems: "center", justifyContent: "center",
        margin: "0 auto 16px", fontSize: 36, boxShadow: "0 8px 24px rgba(22,163,74,0.35)",
      }}>
        ✓
      </div>

      <h2 style={{ fontSize: 22, fontWeight: 800, color: "#111827", marginBottom: 4 }}>
        Paiement réussi !
      </h2>
      <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24 }}>
        {result.is_victron
          ? `Abonnement activé pour ${result.victron_months} mois.`
          : result.kwh > 0
            ? result.is_water
              ? `${Number(result.kwh).toFixed(3)} m³ d'eau ajoutés à votre compteur.`
              : `${Number(result.kwh).toFixed(2)} kWh ajoutés à votre compteur.`
            : "Redevances payées avec succès."}
      </p>

      {result.token && (
        <div style={{ marginBottom: 24 }}>
          <TokenCard
            token={result.token}
            kwh={Number(result.kwh || 0)}
            txnId={result.transaction_id}
            isVictron={result.is_victron}
            isWater={result.is_water || meter.is_water}
            onCopy={() => setCopied(true)}

          />
          {copied && (
            <p style={{ color: "#15803d", fontSize: 13, marginTop: 8, fontWeight: 600 }}>
              ✅ Token copié dans le presse-papiers !
            </p>
          )}
        </div>
      )}

      {/* Résumé */}
      <div style={{
        background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 14,
        padding: "16px", textAlign: "left", marginBottom: 20, fontSize: 13,
      }}>
        <p style={{ fontWeight: 700, marginBottom: 10, color: "#374151" }}>Détails</p>
        {[
          ["Référence", result.transaction_id],
          ["Compteur", meter.meter_id],
          ["Client", meter.customer_name],
          ["Montant payé", `${fmt(result.amount)} FCFA`],
          ...(result.fee_deducted > 0
            ? [["Redevances", `${fmt(result.fee_deducted)} FCFA`]]
            : []),
          ...(result.is_victron
            ? [["Expire le", result.victron_expiry_date
              ? new Date(result.victron_expiry_date).toLocaleDateString("fr-FR")
              : "—"]]
            : result.kwh > 0
              ? [(result.is_water || meter.is_water)
                  ? ["Volume d'eau", `${Number(result.kwh).toFixed(3)} m³`]
                  : ["Crédit électricité", `${Number(result.kwh).toFixed(2)} kWh`]]
              : []),
          ["Mode de paiement", result.payment_method],
        ].map(([k, v]) => (
          <div key={k} style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
            <span style={{ color: "#6b7280" }}>{k}</span>
            <span style={{ fontWeight: 600, color: "#111827" }}>{v}</span>
          </div>
        ))}
      </div>

      {result.meter_unblocked && (
        <div style={{
          background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: 10,
          padding: "10px 14px", marginBottom: 16, color: "#14532d",
          fontWeight: 600, fontSize: 13,
        }}>
          🔓 Votre compteur a été débloqué !
        </div>
      )}

      <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
        <button
          onClick={onNewPurchase}
          style={{
            width: "100%", padding: "14px",
            background: "linear-gradient(135deg, #16a34a, #15803d)",
            color: "#fff", border: "none", borderRadius: 12, fontWeight: 700,
            fontSize: 15, cursor: "pointer", display: "flex", alignItems: "center",
            justifyContent: "center", gap: 8,
          }}
        >
          <BoltIcon size={16} color="#fff" /> Nouvelle recharge
        </button>
        <button
          onClick={onHistory}
          style={{
            width: "100%", padding: "13px", background: "transparent", color: "#374151",
            border: "1.5px solid #d1d5db", borderRadius: 12, fontWeight: 600,
            fontSize: 14, cursor: "pointer",
          }}
        >
          📋 Voir l'historique
        </button>
      </div>
    </div>
  );
}

// ── SECTION: Historique ───────────────────────────────────────────────────────

function HistoryPanel({ meter, onBack }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const PER_PAGE = 10;

  const load = useCallback(
    async (p = 0) => {
      setLoading(true);
      try {
        const data = await apiFetch(
          `/client/history/${meter.meter_id}?skip=${p * PER_PAGE}&limit=${PER_PAGE}`
        );
        setItems(data.items);
        setTotal(data.total);
        setPage(p);
      } catch (_) { }
      finally { setLoading(false); }
    },
    [meter.meter_id]
  );

  useEffect(() => { load(0); }, [load]);

  const totalPages = Math.ceil(total / PER_PAGE);

  const methodBadge = (m) => {
    const map = {
      wave: { bg: "#dcfce7", color: "#16a34a", icon: <WaveIcon size={14} /> },
      orange_money: { bg: "#ffedd5", color: "#c2410c", icon: <OrangeMoneyIcon size={14} /> },
      cash: { bg: "#f0fdf4", color: "#16a34a", icon: "💵" },
    };
    const s = map[m] || { bg: "#f1f5f9", color: "#475569", icon: "💳" };
    return (
      <span style={{
        background: s.bg, color: s.color, borderRadius: 20, padding: "2px 10px",
        fontSize: 11, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 5,
      }}>
        {s.icon} {m === "orange_money" ? "OM" : m}
      </span>
    );
  };

  return (
    <div>
      <button
        onClick={onBack}
        style={{
          background: "none", border: "none", cursor: "pointer", color: "#6b7280",
          fontSize: 13, display: "flex", alignItems: "center", gap: 6,
          marginBottom: 16, padding: 0,
        }}
      >
        ← Retour
      </button>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <h3 style={{ fontSize: 18, fontWeight: 800, color: "#111827", margin: 0 }}>
            Historique
          </h3>
          <p style={{ fontSize: 12, color: "#6b7280", margin: "2px 0 0 0" }}>
            Compteur {meter.meter_id} — {total} transaction(s)
          </p>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spinner size={32} />
          <p style={{ color: "#9ca3af", marginTop: 12 }}>Chargement…</p>
        </div>
      ) : items.length === 0 ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📭</div>
          <p style={{ color: "#9ca3af" }}>Aucune transaction pour ce compteur.</p>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {items.map((t) => (
              <div key={t.transaction_id} style={{
                background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 14,
                padding: "14px 16px", transition: "box-shadow 0.2s",
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                  <div>
                    <p style={{ fontSize: 13, fontWeight: 700, color: "#111827", margin: 0 }}>
                      {fmt(t.amount)} FCFA
                    </p>
                    <p style={{ fontSize: 11, color: "#9ca3af", margin: "2px 0 0 0", fontFamily: "monospace" }}>
                      {t.transaction_id.slice(0, 18)}…
                    </p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {methodBadge(t.payment_method)}
                    <p style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                      {fmtDate(t.created_at)}
                    </p>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {t.kwh > 0 && (
                    <span style={{
                      background: "#f0fdf4", color: "#16a34a", borderRadius: 20,
                      padding: "2px 10px", fontSize: 11, fontWeight: 600,
                      display: "inline-flex", alignItems: "center", gap: 4,
                    }}>
                      {meter.is_water
                        ? <>💧 {Number(t.kwh).toFixed(3)} m³</>
                        : <><BoltIcon size={11} color="#16a34a" /> {Number(t.kwh).toFixed(2)} kWh</>}
                    </span>
                  )}
                  {/* <span style={{
                    background: t.status === "completed" ? "#f0fdf4" : "#fef2f2",
                    color: t.status === "completed" ? "#16a34a" : "#991b1b",
                    borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 600,
                  }}>
                    {t.status === "completed" ? "✅ Validée" : "❌ Échouée"}
                  </span> */}
                  {statusBadge(t.status)}
                </div>

                {t.token && (
                  <div style={{
                    background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 8,
                    padding: "8px 12px", marginTop: 10,
                  }}>
                    <p style={{ fontSize: 10, color: "#16a34a", margin: "0 0 2px 0", fontWeight: 600 }}>
                      TOKEN
                    </p>
                    <p style={{
                      fontFamily: "monospace", fontSize: 14, fontWeight: 800, color: "#14532d",
                      margin: 0, letterSpacing: 2, wordBreak: "break-all",
                    }}>
                      {t.token.replace(/\s/g, '').match(/.{1,4}/g)?.join("  ") || t.token}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 20 }}>
              <button
                onClick={() => load(page - 1)}
                disabled={page === 0}
                style={{
                  padding: "8px 16px", border: "1.5px solid #d1d5db", borderRadius: 8,
                  background: page === 0 ? "#f3f4f6" : "#fff",
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  color: page === 0 ? "#9ca3af" : "#374151", fontWeight: 600, fontSize: 13,
                }}
              >
                ← Préc.
              </button>
              <span style={{ padding: "8px 16px", fontSize: 13, color: "#6b7280" }}>
                {page + 1} / {totalPages}
              </span>
              <button
                onClick={() => load(page + 1)}
                disabled={page >= totalPages - 1}
                style={{
                  padding: "8px 16px", border: "1.5px solid #d1d5db", borderRadius: 8,
                  background: page >= totalPages - 1 ? "#f3f4f6" : "#fff",
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151", fontWeight: 600, fontSize: 13,
                }}
              >
                Suiv. →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// ── PAGE PRINCIPALE ───────────────────────────────────────────────────────────
export default function ClientPortal() {
  const [step, setStep] = useState("lookup");
  const [meter, setMeter] = useState(null);
  const [result, setResult] = useState(null);
  const [toast, setToast] = useState(null);
  const [pendingCheckout, setPendingCheckout] = useState(null);

  const showToast = useCallback((msg, type = "info") => {
    setToast({ msg, type, id: Date.now() });
  }, []);

  // useEffect(() => {
  //   const savedMeter = localStorage.getItem("madpower_last_meter");
  //   const savedCheckout = localStorage.getItem("madpower_pending_checkout");

  //   if (savedCheckout && savedMeter) {
  //     const meterData = JSON.parse(savedMeter);
  //     setMeter(meterData);
  //     setPendingCheckout(savedCheckout);
  //     setStep("waiting");
  //   }
  // }, []);
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");
  const savedCheckout = localStorage.getItem("madpower_pending_checkout");
  const savedMeter = localStorage.getItem("madpower_last_meter");

  if (status === "error" && savedCheckout) {
    // ✅ Wave a redirigé ici parce que le client a annulé (croix)
    apiFetch(`/client/purchase/wave/cancel/${savedCheckout}`, { method: "POST" }).catch(() => {});
    localStorage.removeItem("madpower_pending_checkout");
    setPendingCheckout(null);
    showToast("Paiement annulé.", "error");

    if (savedMeter) {
      setMeter(JSON.parse(savedMeter));
      setStep("purchase");
    } else {
      setStep("lookup");
    }

    window.history.replaceState({}, "", window.location.pathname);
    return;
  }

  if (status === "success") {
    window.history.replaceState({}, "", window.location.pathname);
  }

  if (savedCheckout && savedMeter) {
    const meterData = JSON.parse(savedMeter);
    setMeter(meterData);
    setPendingCheckout(savedCheckout);
    setStep("waiting");
  }
}, []);


  useEffect(() => {
    if (!pendingCheckout) return;

    let tries = 0;
    const max = 60;

    const interval = setInterval(async () => {
      tries++;
      if (tries > max) {
        clearInterval(interval);
        localStorage.removeItem("madpower_pending_checkout");
        setPendingCheckout(null);
        showToast("Délai dépassé. Vérifiez votre historique.", "warning");
        setStep("purchase");
        return;
      }

      try {
        const res = await apiFetch(`/client/purchase/wave/status/${pendingCheckout}`);

        if (res.status === "completed") {
          clearInterval(interval);
          localStorage.removeItem("madpower_pending_checkout");
          setPendingCheckout(null);
          setResult({
            transaction_id: res.transaction_id,
            token: res.token,
            kwh: res.kwh,
            amount: res.amount,
            fee_deducted: res.fee_deducted || 0,
            payment_method: "wave",
            is_victron: res.is_victron || false,
            is_water: res.is_water || false,
            victron_months: res.victron_months,
            victron_expiry_date: res.victron_expiry_date,
          });
          setStep("success");
          showToast("Paiement confirmé ! 🎉", "success");

        } else if (res.status === "processing") {
          // Webhook pas encore arrivé, on continue à poller silencieusement

        // } else if (["failed", "cancelled", "expired"].includes(res.status)) {
        //   clearInterval(interval);
        //   localStorage.removeItem("madpower_pending_checkout");
        //   setPendingCheckout(null);
        //   showToast(res.message || "Paiement échoué.", "error");
        //   setStep("purchase");
        // }
        // APRÈS
        } else if (res.status === "cancelled") {
          clearInterval(interval);
          localStorage.removeItem("madpower_pending_checkout");
          setPendingCheckout(null);
          showToast(res.message || "Paiement annulé.", "warning");
          setStep("purchase");
        } else if (["failed", "expired"].includes(res.status)) {
          clearInterval(interval);
          localStorage.removeItem("madpower_pending_checkout");
          setPendingCheckout(null);
          showToast(res.message || "Paiement échoué.", "error");
          setStep("purchase");
        }

      } catch (_) { }
    }, 2000);

    return () => clearInterval(interval);
  }, [pendingCheckout]);

  const handleMeterLoaded = (data) => {
    localStorage.setItem("madpower_last_meter", JSON.stringify(data));
    setMeter(data);
    setStep("purchase");
  };

  const handleSuccess = (res) => {
    localStorage.removeItem("madpower_pending_checkout");
    setResult(res);
    setStep("success");
  };

  return (
    <>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateX(-50%) translateY(16px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #f3f4f6; }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button { -webkit-appearance: none; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #dcfce7 0%, #f0fdf4 30%, #f0fdf4 70%, #dcfce7 100%)",
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "flex-start", padding: "20px 16px 60px",
      }}>
        <div style={{ textAlign: "center", marginBottom: 24, marginTop: 8 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16, background: "#000",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 10px", boxShadow: "0 8px 24px rgba(0,0,0,0.35)", overflow: "hidden",
          }}>
            <img src={LOGO_DATA_URI} alt="NAAT" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>

          <p style={{
            fontSize: 12, fontWeight: 700, marginTop: 4,
            background: "linear-gradient(90deg, #16a34a, #f97316)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
            backgroundClip: "text", letterSpacing: 0.3,
          }}>
            L'énergie au service de l'excellence
          </p>
        </div>

        {meter && !["lookup", "success", "waiting"].includes(step) && (
          <div style={{
            display: "flex", background: "#fff", borderRadius: 12, padding: 4,
            marginBottom: 16, width: "100%", maxWidth: 440, boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}>
            {[
              { key: "purchase", label: "Acheter", icon: <BoltIcon size={14} color={step === "purchase" ? "#fff" : "#6b7280"} /> },
              { key: "history", label: "Historique", icon: "📋" },
            ].map((tab) => (
              <button key={tab.key} onClick={() => setStep(tab.key)} style={{
                flex: 1, padding: "10px", border: "none", borderRadius: 10,
                background: step === tab.key ? "#15803d" : "transparent",
                color: step === tab.key ? "#fff" : "#6b7280", fontWeight: 700, fontSize: 14,
                cursor: "pointer", transition: "all 0.2s", display: "flex",
                alignItems: "center", justifyContent: "center", gap: 6,
              }}>
                {typeof tab.icon === "string" ? tab.icon : tab.icon} {tab.label}
              </button>
            ))}
          </div>
        )}

        <div style={{
          background: "#fff", borderRadius: 24, padding: "28px 24px",
          width: "100%", maxWidth: 440,
          boxShadow: "0 20px 60px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.04)",
          animation: "fadeIn 0.35s ease",
        }}>
          {step === "lookup" && <MeterLookup onMeterLoaded={handleMeterLoaded} />}

          {step === "waiting" && (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <Spinner size={48} color="#15803d" />
              <h2 style={{ fontSize: 18, fontWeight: 800, color: "#111827", marginTop: 20, marginBottom: 8 }}>
                Vérification du paiement...
              </h2>
              <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.6 }}>
                Votre paiement est en cours de confirmation.<br />
                Veuillez patienter quelques secondes.
              </p>
              <button
                // onClick={async () => {
                //     try { await apiFetch(`/client/purchase/wave/cancel/${checkoutId}`, { method: "POST" }); } catch (_) {}
                //     stopPolling(); setWavePolling(false); setWaveUrl("");
                //   }}
                onClick={() => {
                  localStorage.removeItem("madpower_pending_checkout");
                  setPendingCheckout(null);
                  setStep(meter ? "purchase" : "lookup");
                }}
                style={{
                  marginTop: 20, background: "none", border: "none", color: "#6b7280",
                  cursor: "pointer", fontSize: 12, textDecoration: "underline",
                }}
              >
                Annuler
              </button>
            </div>
          )}

          {step === "purchase" && meter && (
            <PurchasePanel
              meter={meter}
              onBack={() => {
                localStorage.removeItem("madpower_last_meter");
                setMeter(null);
                setStep("lookup");
              }}
              onSuccess={handleSuccess}
              showToast={showToast}
            />
          )}

          {step === "success" && result && meter && (
            <SuccessPanel
              result={result}
              meter={meter}
              onNewPurchase={() => setStep("purchase")}
              onHistory={() => setStep("history")}
            />
          )}

          {step === "history" && meter && (
            <HistoryPanel
              meter={meter}
              onBack={() => setStep(result ? "success" : "purchase")}
            />
          )}
        </div>

        <p style={{ marginTop: 24, fontSize: 11, color: "#9ca3af", textAlign: "center" }}>
          NAAT — Système de gestion d'énergie prépayée<br />
          En cas de problème, contactez notre support au +221 78 192 12 12.
        </p>
      </div>

      {toast && (
        <Toast key={toast.id} msg={toast.msg} type={toast.type} onClose={() => setToast(null)} />
      )}
    </>
  );
}